document.addEventListener("DOMContentLoaded", (event) => {

    let loadMore = document.getElementById('load-more');

    function setajaxLoadMore(id, index){
        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
              cat: id,
              index: index,
              action: 'load_more',
            },
            success: function(res) {
                $('#fach-news').html(res);
            }
          })
    }


    if(loadMore){
        let fachNews = document.getElementById('fach-news');
        let cat = fachNews.dataset.cat;
        console.log(cat);

        var $ = require( "jquery" );

        loadMore.addEventListener('click', ()=>{
            let index = loadMore.dataset.index;
            setajaxLoadMore(cat, index);
        });

        $(document).on({
            ajaxStart: function() { 

            },
            ajaxStop: function() { 
                let numberofcards = document.getElementsByClassName('card-main');

                if(loadMore.dataset.max == numberofcards.length){
                    loadMore.parentElement.classList.add('hidden');
                }else{
                    loadMore.dataset.index = numberofcards.length;
                }
            },
        });
    }
});